window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on("shopify:section:load", this._onSectionLoad.bind(this))
    .on("shopify:section:unload", this._onSectionUnload.bind(this))
    .on("shopify:section:select", this._onSelect.bind(this))
    .on("shopify:section:deselect", this._onDeselect.bind(this))
    .on("shopify:block:select", this._onBlockSelect.bind(this))
    .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr("data-section-id");
    var type = $container.attr("data-section-type");

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $("[data-section-id]", evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $("[data-section-type=" + type + "]").each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
    );
    var $iframeReset = $iframeVideo.add(".rte iframe#admin_bar_iframe");

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = "js-focus-hidden";

    $element
      .first()
      .attr("tabIndex", "-1")
      .focus()
      .addClass(focusClass)
      .one("blur", callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr("tabindex");
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $("a[href*=#]").on(
      "click",
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr("tabindex", "-1");
    options.$elementToFocus.focus();

    $(document).off("focusin");

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? "focusin." + options.namespace
      : "focusin";

    if (options.$container && options.$container.length) {
      options.$container.removeAttr("tabindex");
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === "string") {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
    );

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, "");
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(
      number,
      precision,
      thousands,
      decimal,
      noTrailingZeros
    ) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";

      if (parts[1] == "00" && noTrailingZeros) {
        return dollarsAmount;
      } else {
        return dollarsAmount + centsAmount;
      }
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_trailing_zeros":
        value = formatWithDelimiters(cents, 2, ",", ".", true);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      "change",
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr("type");
          var currentOption = {};

          if (type === "radio" || type === "checkbox") {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data("index");

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data("index");

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: "variantChange",
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantImageChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: "variantPriceChange",
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: "variantSKUChange",
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?variant=" +
        variant.id;
      window.history.replaceState({ path: newurl }, "", newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

/* ================ Custom Helpers ================ */

/**
 * API Helpers
 * --------------------------
 */

if (typeof ShopifyAPI === "undefined") {
  ShopifyAPI = {};
}

ShopifyAPI.getProducts = function(url, callback) {
  jQuery
    .getJSON(url, null, null)
    .done(function(data) {
      if (callback) {
        callback(data);
      }
    })
    .fail(function(jqXHR, textStatus) {
      ShopifyAPI.onError(jqXHR, textStatus);
    })
    .always(function() {
      console.log("Finished getting products!");
    });
};

/**
 * String Helpers
 * ----------------------------
 * from https://github.com/Shopify/liquid/blob/63eb1aac69a31d97e343822b973b3a51941c8ac2/performance/shopify/shop_filter.rb#L100
 */

theme.handleize = function(str) {
  str = str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");

  // replacing-accented-characters-with-plain-ascii-ones
  var defaultDiacriticsRemovalMap = [
    {
      base: "A",
      letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
    },
    { base: "AA", letters: /[\uA732]/g },
    { base: "AE", letters: /[\u00C6\u01FC\u01E2]/g },
    { base: "AO", letters: /[\uA734]/g },
    { base: "AU", letters: /[\uA736]/g },
    { base: "AV", letters: /[\uA738\uA73A]/g },
    { base: "AY", letters: /[\uA73C]/g },
    {
      base: "B",
      letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
    },
    {
      base: "C",
      letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
    },
    {
      base: "D",
      letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
    },
    { base: "DZ", letters: /[\u01F1\u01C4]/g },
    { base: "Dz", letters: /[\u01F2\u01C5]/g },
    {
      base: "E",
      letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
    },
    { base: "F", letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
    {
      base: "G",
      letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
    },
    {
      base: "H",
      letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
    },
    {
      base: "I",
      letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
    },
    { base: "J", letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
    {
      base: "K",
      letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
    },
    {
      base: "L",
      letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
    },
    { base: "LJ", letters: /[\u01C7]/g },
    { base: "Lj", letters: /[\u01C8]/g },
    {
      base: "M",
      letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
    },
    {
      base: "N",
      letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
    },
    { base: "NJ", letters: /[\u01CA]/g },
    { base: "Nj", letters: /[\u01CB]/g },
    {
      base: "O",
      letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
    },
    { base: "OI", letters: /[\u01A2]/g },
    { base: "OO", letters: /[\uA74E]/g },
    { base: "OU", letters: /[\u0222]/g },
    {
      base: "P",
      letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
    },
    { base: "Q", letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
    {
      base: "R",
      letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
    },
    {
      base: "S",
      letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
    },
    {
      base: "T",
      letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
    },
    { base: "TZ", letters: /[\uA728]/g },
    {
      base: "U",
      letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
    },
    {
      base: "V",
      letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
    },
    { base: "VY", letters: /[\uA760]/g },
    {
      base: "W",
      letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
    },
    { base: "X", letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
    {
      base: "Y",
      letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
    },
    {
      base: "Z",
      letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
    },
    {
      base: "a",
      letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
    },
    { base: "aa", letters: /[\uA733]/g },
    { base: "ae", letters: /[\u00E6\u01FD\u01E3]/g },
    { base: "ao", letters: /[\uA735]/g },
    { base: "au", letters: /[\uA737]/g },
    { base: "av", letters: /[\uA739\uA73B]/g },
    { base: "ay", letters: /[\uA73D]/g },
    {
      base: "b",
      letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
    },
    {
      base: "c",
      letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
    },
    {
      base: "d",
      letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
    },
    { base: "dz", letters: /[\u01F3\u01C6]/g },
    {
      base: "e",
      letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
    },
    { base: "f", letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
    {
      base: "g",
      letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
    },
    {
      base: "h",
      letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
    },
    { base: "hv", letters: /[\u0195]/g },
    {
      base: "i",
      letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
    },
    { base: "j", letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
    {
      base: "k",
      letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
    },
    {
      base: "l",
      letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
    },
    { base: "lj", letters: /[\u01C9]/g },
    {
      base: "m",
      letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
    },
    {
      base: "n",
      letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
    },
    { base: "nj", letters: /[\u01CC]/g },
    {
      base: "o",
      letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
    },
    { base: "oi", letters: /[\u01A3]/g },
    { base: "ou", letters: /[\u0223]/g },
    { base: "oo", letters: /[\uA74F]/g },
    {
      base: "p",
      letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
    },
    { base: "q", letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
    {
      base: "r",
      letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
    },
    {
      base: "s",
      letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
    },
    {
      base: "t",
      letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
    },
    { base: "tz", letters: /[\uA729]/g },
    {
      base: "u",
      letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
    },
    {
      base: "v",
      letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
    },
    { base: "vy", letters: /[\uA761]/g },
    {
      base: "w",
      letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
    },
    { base: "x", letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
    {
      base: "y",
      letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
    },
    {
      base: "z",
      letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
    }
  ];

  for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(
      defaultDiacriticsRemovalMap[i].letters,
      defaultDiacriticsRemovalMap[i].base
    );
  }

  return str;
};

/**
 * Linear Data Helper
 * --------------------------
 * Linear data flow
 *
 */

theme.Line = (function(value) {
  function Line(value) {
    this.value = value;
  }

  Line.prototype = _.assignIn({}, Line.prototype, {
    copy: function() {
      if (Array.isArray(this.value)) {
        return this.value.slice();
      } else if (typeof this.value == "string") {
        return this.value;
      }
    },

    then: function(f) {
      return new theme.Line(f(this.value));
    },

    prepend: function(item) {
      if (Array.isArray(this.value)) {
        this.value.unshift(item);
      } else if (typeof this.value == "string") {
        this.value = item + this.value;
      }

      return new theme.Line(this.value);
    },

    remove: function(item) {
      if (Array.isArray(this.value)) {
        var index = this.value.indexOf(item);
        this.value.splice(index, 1);
      } else if (typeof this.value == "string") {
        this.value = this.value.split(item).join("");
      }

      return new theme.Line(this.value);
    },

    // string

    toString: function() {
      return new theme.Line(this.value.toString());
    },

    toLowerCase: function() {
      return new theme.Line(this.value.toLowerCase());
    },

    toUpperCase: function() {
      return new theme.Line(this.value.toUpperCase());
    },

    split: function(spliter) {
      return new theme.Line(this.value.split(spliter));
    },

    concat: function(str) {
      return new theme.Line(this.value.concat(str));
    },

    // array
    map: function(f) {
      this.value = this.value.map(f);
      return new theme.Line(this.value);
    },

    join: function(joiner) {
      this.value = this.value.join(joiner);
      return new theme.Line(this.value);
    },

    push: function(item) {
      this.value.push(item);
      return new theme.Line(this.value);
    },

    pop: function() {
      this.value.pop();
      return new theme.Line(this.value);
    },

    shift: function() {
      this.value.shift();
      return new theme.Line(this.value);
    },

    first: function() {
      var value = this.value.splice(0, 1);
      return new theme.Line(value);
    },

    last: function() {
      var value = this.value.splice(-1);
      return new Line(value);
    },

    splice: function(index, count, item) {
      if (!item) {
        var value = this.value.splice(index, count);
      } else {
        var value = this.value.splice(index, count, item);
      }

      return new theme.Line(value);
    },

    insert: function(index, item) {
      var value = this.value.splice(index, 0, item);
      return new theme.Line(value);
    },

    deArray: function() {
      return new theme.Line(this.value[0]);
    },

    fold: function() {
      return this.value;
    }
  });

  return Line;
})();

/**
 * Date Helper
 * --------------------------
 */

theme.Date = (function(value) {
  // private virables
  var millisecondsPerSec = 1000,
    millisecondsPerMin = 60 * 1000,
    millisecondsPerHour = 60 * 60 * 1000,
    millisecondsPerDay = 24 * 60 * 60 * 1000,
    millisecondsPerMonth = 30 * millisecondsPerDay,
    millisecondsPerYear = 12 * millisecondsPerMonth;

  // helper functions
  var toUTC = function(date) {
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  };

  var getTimeDist = function(startDate, endDate, unit, getLegalTime) {
    var unit = !unit ? "milliseconds" : unit.toLowerCase(),
      // millisecondsPerDay = 24 * 60 * 60 * 1000,
      // millisecondsPerMonth = 30 * millisecondsPerDay,
      // millisecondsPerYear = 12 * millisecondsPerMonth,
      millisecondsSpan = toUTC(endDate) - toUTC(startDate),
      result = {
        unti: unit,
        value: 0
      };

    switch (unit) {
      case "year":
        result.value = Math.floor(millisecondsSpan / millisecondsPerYear); // years
        break;
      case "month":
        result.value = Math.floor(millisecondsSpan / millisecondsPerMonth); // months
        break;
      case "day":
        result.value = Math.floor(millisecondsSpan / millisecondsPerDay); // days
        break;
      case "hour":
        result.value = Math.floor(millisecondsSpan / millisecondsPerHour); // hours
        break;
      case "minute":
        result.value = Math.floor(millisecondsSpan / millisecondsPerMin); // minutes
        break;
      case "second":
        result.value = Math.floor(millisecondsSpan / millisecondsPerSec); // seconds
      default:
        result.value = millisecondsSpan; // milliseconds
    }

    if (getLegalTime) {
      result.value = legalize(result.value);
    }

    return result;
  };

  var getTimeSpan = function() {};

  var reset = function(date) {
    var year = date.getFullYear(),
      month = new theme.Line(date.getMonth() + 1).then(legalize).fold(),
      day = new theme.Line(date.getDate()).then(legalize).fold(),
      dateStr = [month, day, year].join("/");

    return new Date(dateStr);
  };

  var legalize = function(num) {
    return parseInt(num) >= 10 ? num : "0" + num;
  };

  var getTomorrow = function() {
    var today = new Date();
    return new Date(today.getTime() + millisecondsPerDay);
  };

  return {
    toUTC: toUTC,
    getTimeSpan: getTimeSpan,
    getTimeDist: getTimeDist,
    getTomorrow: getTomorrow,
    reset: reset,
    legalize: legalize
  };
})();

/**
 * Local Storage Helper
 * --------------------------
 */

theme.Storage = (function() {
  var set = function(key, value, expiration) {
    var _value = {
      value: value,
      expiration: expiration,
      createdAt: new Date()
    };

    localStorage.setItem(key, JSON.stringify(_value));
  };

  var get = function(key) {
    // _value saved as string
    var _valueRaw = localStorage.getItem(key);

    if (!_valueRaw) {
      // when item doesn't exist
      console.log("Item doesn't exist!");
      return undefined;
    } else {
      // when item exist
      var _value = JSON.parse(_valueRaw);

      if (!_value.expiration) {
        // if doesn't have an expiration date
        return _value.value;
      } else {
        // check expiration
        if (new Date(_value.expiration) > new Date()) {
          return _value.value;
        } else {
          this.remove(key);
          console.log("This item is expired!");
          return undefined;
        }
      }
    }
  };

  var remove = function(key) {
    return localStorage.removeItem(key);
  };

  var checkExpiration = function(key) {
    // _value saved as string
    var _valueRaw = localStorage.getItem(key);

    if (!_valueRaw) {
      console.log("Item doesn't exist!");
      return undefined;
    } else {
      var expiration = JSON.parse(_valueRaw).expiration;
      if (!expiration) {
        console.log("This item doesn't have expiration date!");
        return undefined;
      } else {
        var isExpired = new Date(expiration) > new Date() ? false : true;
        return isExpired;
      }
    }
  };

  return {
    set: set,
    get: get,
    remove: remove,
    checkExpiration: checkExpiration
  };
})();

/**
 * Decouple Event Helper
 * --------------------------
 *
 * https://github.com/pazguille/decouple
 * Modified event binder, added a variable to check if it's animation
 */

theme.Decouple = (function() {
  var requestAnimFrame = (function() {
    return (
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      function(callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })().bind(window);

  var decouple = function(node, event, fn, isAnimation) {
    var eve,
      tracking = false;

    function captureEvent(e) {
      eve = e;
      track();
    }

    function track() {
      if (!tracking) {
        if (isAnimation == false) {
          // console.log('setting time out');
          setTimeout(update, 500);
        } else {
          requestAnimFrame(update);
        }

        tracking = true;
      }
    }

    function update() {
      // console.log('time out');
      fn.call(node, eve);
      tracking = false;
    }

    $(node).on(event, captureEvent);

    return captureEvent;
  };

  return decouple;
})();

/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: ".js-drawer-close-" + position,
      open: ".js-drawer-open-" + position,
      openClass: "js-drawer-open",
      dirOpenClass: "js-drawer-open-" + position
    };

    this.nodes = {
      $parent: $("html").add("body"),
      $page: $("#PageContainer")
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $("#" + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on("click", $.proxy(this.open, this));
    $(this.config.close).on("click", $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + " " + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === "function"
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr("aria-expanded")) {
      this.$activeSource.attr("aria-expanded", "true");
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function(evt) {
    // console.log($(evt.target));
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger("blur");
    // console.log(this.$drawer);
    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + " " + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: "drawer_focus"
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      "keyup.drawer",
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on("touchmove.drawer", function() {
      return false;
    });

    this.nodes.$page.on(
      "click.drawer",
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off(".drawer");
    this.nodes.$parent.off(".drawer");
  };

  return Drawer;
})();

/*============================================================================
  Modal
==============================================================================*/
theme.Modal = (function() {
  var init, open, close, bindEvents, off;

  var selectors = {
    modal: ".modal",
    modalInner: ".modal-inner",
    modalOpen: ".js-modal-open",
    modalClose: ".js-modal-close"
  };

  var cache = {
    $modal: $(selectors.modal),
    $modalInner: $(selectors.modalInner),
    $modalOpen: $(selectors.modalOpen),
    $modalClose: $(selectors.modalClose)
  };

  var classes = {
    activeModal: "modal--is-active"
  };

  init = function() {
    cache.$modalOpen.on("click.modal", open);
    cache.$modal.on("click.modal", close);
    bindEvents();
  };

  open = function(evt) {
    var $this = $(evt.target),
      target = $this.data("target"),
      $modal = $(target);

    $modal.addClass(classes.activeModal);
  };

  close = function(evt) {
    var onESC = evt.keyCode ? true : false,
      $this = $(evt.target),
      $modal = onESC
        ? $("." + classes.activeModal)
        : $this.closest("." + classes.activeModal);

    if (
      $this.hasClass("modal-inner") ||
      $this.hasClass("js-modal-close") ||
      onESC
    ) {
      $modal.removeClass(classes.activeModal);
    }
  };

  bindEvents = function() {
    $(document).on("keyup.modal", function(evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        close(evt);
        return false;
      } else {
        return true;
      }
    });
  };

  off = function() {
    cache.$modalOpen.off(".modal");
    cache.$modal.off(".modal");
    $(document).off(".modal");
  };

  return {
    init: init,
    off: off
  };
})();

/*============================================================================
  Collapse
==============================================================================*/
theme.Collapse = (function() {
  function Collapse(settings) {
    var config = {
      collapse_toggle_selector: ".collapse-header",
      collapse_toggle_open_class: "collapse-header--open",
      collapse_bd_selector: ".collapse-bd",
      collapse_bd_open_class: "collapse-bd--open",
      toggle_icon_selector: ".js-toggle-icon",
      toggle_icon_open_class: "js-toggle-icon--open",
      event: "click",
      delay: 250,
      time: 500,
      cb: function() {}
    };

    this.config = $.extend({}, config, settings);

    this.cache = {
      $collapseToggle: $(this.config.collapse_toggle_selector),
      $toggleIcon: $(this.config.toggle_icon_selector)
    };

    // if has customized collapse bd
    if (!/'\.collapse-bd'/.test(config.collapse_bd_selector)) {
      this.cache.$collapseBody = $(this.config.collapse_bd_selector);
    } else {
      // look for the closest default one
      this.cache.$collapseBody =
        this.cache.$collapseToggle.siblings(".collapse-bd").length > 0
          ? this.cache.$collapseToggle.siblings(".collapse-bd")
          : this.cache.$collapseToggle.parent().siblings(".collapse-bd");
    }

    // return if there is no collapse body
    if (!this.cache.$collapseBody.length) {
      console.log("Please specify a collapse body!");
      return;
    }

    this._init();
  }

  Collapse.prototype = _.assignIn({}, Collapse.prototype, {
    _init: function() {
      var self = this,
        event = this.config.event;

      this.cache.$collapseToggle.on(event, function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        self._toggleCollapse();
      });
    },

    _toggleCollapse: function() {
      var self = this,
        time = this.config.time,
        delay = this.config.delay,
        cb = this.config.cb,
        toggleIconOpenClass = this.config.toggle_icon_open_class,
        collapseToggleOpenClass = this.config.collapse_toggle_open_class,
        collapseBdOpenClass = this.config.collapse_bd_open_class;

      this.cache.$collapseBody.slideToggle(time, "swing");

      setTimeout(function() {
        self.cache.$collapseToggle.toggleClass(collapseToggleOpenClass);
        self.cache.$toggleIcon.toggleClass(toggleIconOpenClass);
      }, delay);

      setTimeout(function() {
        self.cache.$collapseBody.toggleClass(collapseBdOpenClass);
      }, time);

      if (typeof cb !== "undefined") {
        cb.bind(this.cache.$collapseToggle)();
      }
    },

    onUnload: function() {}
  });

  return Collapse;
})();

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  // var selectors = {
  //   navigation: '#AccessibleNav'
  // };

  // var config = {
  //   activeClass: 'has-active-dropdown',
  //   childLinkClass: 'site-nav__child-link'
  // };

  // var cache = {
  //   $nav: $(selectors.navigation)
  // };

  function init() {}

  function unload() {}

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    open: "js-drawer-open-left"
  };

  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQueryMediumDown = "screen and (max-width: 1023px)";

  function init() {
    // init mobile nav
    var MobileNavDrawer = new theme.Drawers("MobileNavDrawer", "left", {
      open: ".js-mobile-nav-open",
      close: ".js-mobile-nav-close"
    });

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQueryMediumDown, {
      unmatch: function() {
        if ($(document.body).hasClass(classes.open)) {
          MobileNavDrawer.close.call(MobileNavDrawer);
        }
      }
    });

    new theme.Collapse({
      collapse_toggle_selector: ".js-mobile-subnav-toggle",
      collapse_toggle_open_class: "js-mobile-subnav-toggle--open",
      collapse_bd_selector: ".mobile-nav__subnav",
      collapse_bd_open_class: "mobile-nav__subnav--open"
    });
  }

  function unload() {
    // nothing to do
  }

  return {
    init: init,
    unload: unload
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: ".js-search",
    searchSubmit: ".js-search .input-group__submit--left",
    searchInput: ".js-search .input-group__field",

    siteHeader: ".site-header"
  };

  var classes = {
    focus: "search--focus",
    hasContent: "js-has-content"
    // mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    $(selectors.searchInput).on("focus", function() {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      $searchForm.addClass(classes.focus);
    });

    $(selectors.searchInput).on("blur", function(evt) {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      $searchForm.removeClass(classes.focus);

      if (
        evt.target.value.length == 0 &&
        $searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.removeClass(classes.hasContent);
      }
    });

    $(selectors.searchInput).on("keyup", function(evt) {
      var $searchForm = $(this).parent(),
        $searchSubmit = $(this).siblings(selectors.searchSubmit);

      $searchSubmit.prepareTransition();
      if (
        evt.target.value.length > 0 &&
        !$searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.addClass(classes.hasContent);
      } else if (
        evt.target.value.length == 0 &&
        $searchForm.hasClass(classes.hasContent)
      ) {
        $searchForm.removeClass(classes.hasContent);
      }
    });

    searchSubmit();
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on("click", function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

theme.Pagination = (function() {
  function init() {
    $(".pagination__link").on("click", function(evt) {
      evt.preventDefault();
      var $this = $(this),
        query = $(this).attr("href"),
        oldQuery = window.location.search,
        newQuery;

      if (oldQuery.length) {
        newQuery = oldQuery.replace(/&?page=\d+/gi, "").concat("&" + query);
        window.location.search = newQuery;
      } else {
        window.location.search = "?" + query;
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: ".return-link"
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one("click", function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement("a");
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  this.sectionId;

  var classes = {
    wrapper: "slideshow-wrapper",
    slideshow: "slideshow",
    currentSlide: "slick-current",
    video: "slideshow__video",
    videoBackground: "slideshow__video--background",
    closeVideoBtn: "slideshow__video-control--close",
    pauseButton: "slideshow__pause",
    isPaused: "is-paused"
  };

  function slideshow(el) {
    var self = this;
    this.$slideshow = $(el);
    this.sectionId = el.substr(11);
    this.$wrapper = this.$slideshow.closest("." + classes.wrapper);
    this.$pause = this.$wrapper.find("." + classes.pauseButton);

    this.selectors = {
      slideshowItems:
        ".slideshow-" + this.sectionId + " .slideshow-item-wrapper"
    };

    var slideType = !this.$slideshow.data("slideType")
      ? "scroll"
      : this.$slideshow.data("slideType");
    var slidesToShow = !this.$slideshow.data("slidesToShow")
      ? 5
      : this.$slideshow.data("slidesToShow");
    var slidesToShowSmall = !this.$slideshow.data("slidesToShowSmall")
      ? 1
      : this.$slideshow.data("slidesToShowSmall");
    var slidesToScrollSmall = !this.$slideshow.data("slidesToScrollSmall")
      ? 1
      : this.$slideshow.data("slidesToScrollSmall");
    var slidesBreakpoint = !this.$slideshow.data("breakpoint")
      ? "none"
      : this.$slideshow.data("breakpoint");
    var slidesToScroll = !this.$slideshow.data("slidesToScroll")
      ? 2
      : this.$slideshow.data("slidesToScroll");
    var showDots = !this.$slideshow.data("showDots")
      ? true
      : this.$slideshow.data("showDots");
    var speed = !this.$slideshow.data("speed")
      ? 1000
      : this.$slideshow.data("speed");
    var autoPlay = !this.$slideshow.data("autoplay")
      ? false
      : this.$slideshow.data("autoplay");
    var autoPlaySpeed = !this.$slideshow.data("autoPlaySpeed")
      ? 4000
      : this.$slideshow.data("autoPlaySpeed");
    // console.log('breakpoint', slidesBreakpoint);
    // console.log('type:', slideType);
    // console.log('to show:',slidesToShow);
    // console.log('to show small down:',slidesToShowSmall);
    // console.log('to scroll:',slidesToScroll);

    this.settings = {};

    switch (slideType) {
      case "scroll":
        this.settings = {
          accessibility: true,
          autoplay: autoPlay,
          arrows: true,
          prevArrow: ".slider__prev--" + this.sectionId,
          nextArrow: ".slider__next--" + this.sectionId,
          infinite: true,
          dots: showDots,
          speed: speed,
          slidesToShow: slidesToShow,
          slidesToScroll: slidesToScroll,
          responsive: [
            {
              breakpoint: 639,
              settings: {
                slidesToShow: slidesToShowSmall,
                slidesToScroll: slidesToScrollSmall
              }
            }
          ]
        };
        break;
      case "fade":
        this.settings = {
          accessibility: true,
          draggable: true,
          touchThreshold: 20,
          arrows: false,
          dots: showDots,
          fade: true,
          speed: speed,
          autoplay: autoPlay,
          autoplaySpeed: autoPlaySpeed
        };
    }

    // responsively init/destroy slideshow
    if (slidesBreakpoint != "none") {
      var tracking = false;
      var mq = window.matchMedia(
        "screen and (min-width: " + slidesBreakpoint + "px)"
      );

      $(window).on("load", function() {
        // init slideshow when window size is smaller thant breakpoint
        if (!self.$slideshow.hasClass("slick-initialized") && !mq.matches) {
          self.$slideshow.slick(self.settings);
        }
      });

      $(window).on("resize", function() {
        // init slideshow when window size is smaller thant breakpoint
        if (!self.$slideshow.hasClass("slick-initialized") && !mq.matches) {
          self.$slideshow.slick(self.settings);
        }

        // destroy slideshow when window size is larger thant breakpoint
        if (mq.matches && !tracking) {
          if (self.$slideshow.hasClass("slick-initialized")) {
            tracking = true;
            setTimeout(function() {
              self.$slideshow.slick("unslick");
              // console.log('unslick');
              // console.log('time out');
              tracking = false;
            }, 300);
          }
        }
      });

      // new theme.Decouple(window, 'resize', function() {
      //   // init slideshow when window size is smaller thant breakpoint
      //   if(!self.$slideshow.hasClass('slick-initialized') && window.matchMedia("(max-width: 639px)").matches) {
      //     self.$slideshow.slick(self.settings);
      //   }

      //   // destroy slideshow when window size is larger thant breakpoint
      //   if(self.$slideshow.hasClass('slick-initialized') && window.matchMedia("(min-width: 640px)").matches) {
      //     // self.$slideshow.slick('unslick');
      //     self.$slideshow.slick('unslick');
      //   }
      // }, false);
    } else {
      this.$slideshow.slick(this.settings);
    }

    this.$slideshow.on("beforeChange", beforeChange.bind(this));
    this.$slideshow.on("init", slideshowA11y.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr("aria-live");

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on("focusin", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr("aria-live", "polite");

      if (autoplay) {
        $slider.slick("slickPause");
      }
    });

    // Resume autoplay
    $wrapper.on("focusout", function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr("aria-live");

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick("slickPlay");
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on("keydown", function(evt) {
        if (evt.which === 37) {
          $slider.slick("slickPrev");
        }

        if (evt.which === 39) {
          $slider.slick("slickNext");
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find(".slick-active button").focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find("." + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find("." + classes.video);
      var currentVideoId = $currentVideo.attr("id");
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr("tabindex", "-1");
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find("." + classes.video);
      var videoId = $video.attr("id");
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr("tabindex", "0");
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find("." + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick("slickPlay");
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick("slickPause");
    }
  };

  function getSlideshowId($el) {
    return "#Slideshow-" + $el.data("id");
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: "opaque",
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: "video-is-playing",
    paused: "video-is-paused",
    loading: "video-is-loading",
    loaded: "video-is-loaded",
    slideshowWrapper: "slideshow-wrapper",
    slide: "slideshow__slide",
    slideBackgroundVideo: "slideshow__slide--background-video",
    slideDots: "slick-dots",
    videoChrome: "slideshow__video--chrome",
    videoBackground: "slideshow__video--background",
    playVideoBtn: "slideshow__video-control--play",
    closeVideoBtn: "slideshow__video-control--close",
    currentSlide: "slick-current",
    slickClone: "slick-cloned",
    supportsAutoplay: "autoplay",
    supportsNoAutoplay: "no-autoplay"
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr("id")] = {
      id: $video.attr("id"),
      videoId: $video.data("id"),
      type: $video.data("type"),
      status: $video.data("type") === "chrome" ? "closed" : "background", // closed, open, background
      videoSelector: $video.attr("id"),
      $parentSlide: $video.closest("." + classes.slide),
      $parentSlideshowWrapper: $video.closest("." + classes.slideshowWrapper),
      controls: $video.data("type") === "background" ? 0 : 1,
      slideshow: $video.data("slideshow")
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === "function") {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === "function"
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 768) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality("hd1080");
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $("#" + videoData.id).attr("tabindex", "-1");

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case "background-chrome":
      case "background":
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case "background":
        videoPlayers[videoData.id].seekTo(0);
        break;
      case "background-chrome":
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case "chrome":
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === "background") {
      return;
    }

    $("#" + videoData.id).attr("tabindex", "0");

    switch (videoData.type) {
      case "chrome":
      case "background-chrome":
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find("." + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === "background-chrome") {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== "closed" && videoData.type !== "background") {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === "chrome" && videoData.status === "closed") {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(" ");

    $("#" + videoData.id).attr("tabindex", "-1");

    videoData.status = "closed";

    switch (videoData.type) {
      case "background-chrome":
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case "chrome":
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = "open";

    switch (videoData.type) {
      case "background-chrome":
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case "chrome":
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on("keydown.videoPlayer", function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $("." + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest("." + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $("#" + playerId)
      .removeAttr("style")
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = "open";
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $("#" + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = "background";
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on("click.videoPlayer", "." + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      startVideoOnClick(playerId);
    });

    $(document).on("click.videoPlayer", "." + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data("controls");
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      "resize.videoPlayer",
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off(".videoPlayer");
    $(window).off(".videoPlayer");
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $("#BlogTagFilter");

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on("change", function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $("#RecoverPassword").on("click", function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $("#HideRecoverPasswordLink").on("click", function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $("#AddressNewForm");

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
    }

    // Initialize each edit form's country/province selector
    $(".address-country-option").each(function() {
      var formId = $(this).data("form-id");
      var countrySelector = "AddressCountry_" + formId;
      var provinceSelector = "AddressProvince_" + formId;
      var containerSelector = "AddressProvinceContainer_" + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $(".address-new-toggle").on("click", function() {
      $newAddressForm.toggleClass("hide");
    });

    $(".address-edit-toggle").on("click", function() {
      var formId = $(this).data("form-id");
      $("#EditAddress_" + formId).toggleClass("hide");
    });

    $(".address-delete").on("click", function() {
      var $el = $(this);
      var formId = $el.data("form-id");
      var confirmMessage = $el.data("confirm-message");

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || "Are you sure you wish to delete this address?"
        )
      ) {
        Shopify.postLink("/account/addresses/" + formId, {
          parameters: { _method: "delete" }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var config = {
    showClass: "cart__update--show",
    showEditClass: "cart__edit--active",
    cartNoCookies: "cart--no-cookies"
  };

  var selectors = {
    qtyInput: ".cart__qty-input"
  };

  var cache = {
    $qtyInput: $(selectors.qtyInput)
  };

  function Cart(container) {
    this.$container = $(container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this._initCartQty();
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {},

    _initCartQty: function() {
      cache.$qtyInput.change(function() {
        $(".cart-form").trigger("submit");
      });
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Collection = (function() {
  var constants = {
    SORT_BY: "sort_by"
  };

  var selectors = {
    mobileFilters: "select"
  };

  var cache = {
    $mobileFilters: $(selectors.mobileFilters)
  };

  function Collection(container) {
    var $container = (this.$container = $(container));

    this._initFilterMenu();
  }

  Collection.prototype = _.assignIn({}, Collection.prototype, {
    _initFilterMenu: function() {
      var collectionHandle = this.$container.data("collectionHandle");
      currentFilterRaw = new theme.Line(window.location.pathname)
        .split(collectionHandle)
        .last()
        .toString()
        .toUpperCase()
        .split("/")
        .last()
        .fold()[0];
      currentFilter = currentFilterRaw ? currentFilterRaw : "ALL";

      cache.$mobileFilters.dd({
        main_class: "mobile-filters-wrapper",
        option_list_class: "mobile-filters",
        current_option_class: "current-filter js-mobile-filters-toggle",
        option_class: "filter",
        arrow: {
          enable: false
        },
        autocomplete: true,
        change_callback: function() {
          var href = $(this).attr("rel");
          window.location.href = href;
        },
        init_callback: function() {
          $(".current-filter").text(currentFilter);
        }
      });

      new theme.Collapse({
        collapse_toggle_selector: ".js-mobile-filters-toggle",
        collapse_toggle_open_class: "js-mobile-filters-toggle--open",
        collapse_bd_selector: ".mobile-filters",
        collapse_bd_open_class: "mobile-filters--open"
      });
    },

    onUnload: function() {
      this.$filterSelect.off("change", this._onFilterChange);
      this.$sortSelect.off("change", this._onSortChange);
    }
  });

  return Collection;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.MobileNav.uload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : "";

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === "loaded") {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== "loading") {
        apiStatus = "loading";
        if (typeof window.google === "undefined") {
          $.getScript(
            "https://maps.googleapis.com/maps/api/js?key=" + key
          ).then(function() {
            apiStatus = "loaded";
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data("address-setting");

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find(".map-section__container");

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              "resize",
              $.debounce(250, function() {
                google.maps.event.trigger(map, "resize");
                map.setCenter(center);
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case "ZERO_RESULTS":
              errorMessage = theme.strings.addressNoResults;
              break;
            case "OVER_QUERY_LIMIT":
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass("page-width map-section--load-error")
            .html('<div class="errors text-center">' + errorMessage + "</div>");
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, "resize");
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error");
  $(".map-section__container").remove();
  $(".map-section__link").remove();
  $(".map-section__overlay").after(
    '<div class="errors text-center">' + theme.strings.authError + "</div>"
  );
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container)),
      sectionId = $container.attr("data-section-id");

    this.currentVariant = {};
    this.variantsMap = {};
    this.productSingleObject = {};

    this.config = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      // mediaQueryMediumUp: 'screen and (min-width: 750px)',
      // mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQuery: "screen and (min-width: 768px)",
      enableHistoryState: $container.data("enable-history-state") || false,
      sectionId: sectionId,
      namespace: ".product-template-" + sectionId
    };

    this.selectors = {
      productForm: ".product-form",

      addToCart: "#AddToCart-" + sectionId,
      addToCartText: "#AddToCartText-" + sectionId,
      productPrices: ".product-form__price-" + sectionId,
      comparePrice: "#ComparePrice-" + sectionId,
      originalPriceWrapper: ".product-price__price-" + sectionId,
      originalPrice: "#ProductPrice-" + sectionId,
      saleLabel: ".product-price__sale-label-" + sectionId,
      SKU: ".variant-sku-" + sectionId,
      originalSelectorId: "#ProductSelect-" + sectionId,
      singleOptionSelector: ".single-option-selector",

      swatches: ".swatch",
      swatchItems: ".swatch-element",
      swatchInputs: ".swatch-element__input",
      swatchTooltip: ".swatch-tooltip",

      productPhotosSlider: ".product__photos .slideshow",
      productPhotos: ".product__photo img",

      productTabsNavItem: ".product-tabs__nav-item",
      productTabsItem: ".product-tabs__tab"
    };

    this.classes = {
      unavailableAddToCart: "product-form__cart-submit--unavailable",
      saleClasse: "product-price__sale",
      activeSwatchItem: "swatch-element--active",
      soldoutSwatchItem: "swatch-element--soldout",
      soldoutBtnWrapper: "product-form__submit--soldout",
      activeProductTabNavItem: "product-tabs__nav-item--active"
    };

    this.cache = {
      $productForm: $(this.selectors.productForm),
      $regularPriceWrapper: $(this.selectors.regularPriceWrapper),
      $comparePriceWrapper: $(this.selectors.comparePriceWrapper),
      $comparePrice: $(this.selectors.comparePrice),
      $saleLabel: $(this.selectors.saleLabel),
      $addToCart: $(this.selectors.addToCart),

      $productPhotosSlider: $(
        this.selectors.productPhotosSlider,
        this.$container
      ),
      $productPhotos: $(this.selectors.productPhotos, this.$container),

      $singleOptionSelector: $(
        this.selectors.singleOptionSelector,
        this.$container
      ),
      $swatches: $(this.selectors.swatches, this.$container),
      $swatchItems: $(this.selectors.swatchItems, this.$container),
      $swatchInputs: $(this.selectors.swatchInputs, this.$container),

      $productTabsNavItem: $(
        this.selectors.productTabsNavItem,
        this.$container
      ),
      $productTabsItem: $(this.selectors.productTabsItem, this.$container)
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$("#ProductJson-" + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById("ProductJson-" + sectionId).innerHTML
    );
    // console.log(this.productSingleObject);

    this._preventEnterDefault();
    this._stringOverrides();
    this._initBreakpoints();
    this._initVariants();

    // enable product photos slider
    if (this.cache.$productPhotos.length > 1) {
      this._initProductPhotosSlider();
    }

    // init proeuct tabs
    this._initPorductTabs();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _preventEnterDefault: function() {
      this.cache.$productForm.on("keypress", function(evt) {
        if (evt.which == 13) {
          evt.preventDefault();
        }
      });
    },

    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.config.mediaQuery, {
        match: function() {
          if (self.cache.$productPhotosSlider.hasClass("slick-initialized")) {
            self.cache.$productPhotosSlider.slick("unslick");
          }
        },
        unmatch: function() {
          self._initProductPhotosSlider();
        }
      });
    },

    _initProductPhotosSlider: function() {
      var options = {
          accessibility: true,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrow: false,
          dots: true,
          infinite: true,
          prevArrow: ".product-" + this.config.sectionId + " .slider__prev",
          nextArrow: ".product-" + this.config.sectionId + " .slider__next"
        },
        mq = window.matchMedia(this.config.mediaQuery);

      // init slideshow on mobile
      var mq = window.matchMedia(this.config.mediaQuery);

      if (
        !this.cache.$productPhotosSlider.hasClass("slick-initialized") &&
        this.cache.$productPhotos.length > 1 &&
        !mq.matches
      ) {
        this.cache.$productPhotosSlider.slick(options);
      }
    },

    _initProductPhotosZoomin: function() {
      var $photos = this.cache.$productZoominPhotos;
      var $modal = this.cache.$productModalZoomin;

      $photos.on("click", function(evt) {
        var id = $(this).data("id");
        $modal.find("img").removeClass("active");
        $modal.find('img[data-id="' + id + '"]').addClass("active");
      });
    },

    // update product tabs
    _initPorductTabs: function() {
      var self = this,
        heightList = $.map(self.cache.$productTabsItem, function(ele, i) {
          console.log(typeof $(ele).outerHeight());
          return $(ele).outerHeight();
        }),
        maxHeight = Math.max.apply(null, heightList);

      self.cache.$productTabsItem.css("min-height", maxHeight + "px");

      this.cache.$productTabsNavItem.on(
        "click" + this.config.namespace,
        function() {
          var $this = $(this),
            index = $this.data("index");

          if (!$this.hasClass(self.classes.activeProductTabNavItem)) {
            self.cache.$productTabsNavItem.removeClass(
              self.classes.activeProductTabNavItem
            );
            $this.addClass(self.classes.activeProductTabNavItem);

            self.cache.$productTabsItem.removeClass("show");
            self.cache.$productTabsItem.eq(index).addClass("show");
          }
        }
      );
    },

    // init variants
    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data("enable-history-state") || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      var self = this;

      var slateVariants = new slate.Variants(options);

      // init product swatch on load
      this._initSwatch(slateVariants.currentVariant);
      // check selected swatch elements availablity on load
      this._checkAvailability(slateVariants.currentVariant);
      // hide irrelavent swatch items
      this._hideIrlvtSwatchItems(slateVariants.currentVariant.options[0]);
      // Bind swatch change listener
      this.cache.$swatchInputs.on(
        "change",
        this._handleSwatchOnChange.bind(this)
      );

      // update current variant
      this.$container.on("variantChange", function(evt) {
        this.currentVariant = evt.variant;
        self._checkAvailability(evt.variant);
      });

      this.$container.on("variantChange", this._updateAddToCart.bind(this));
      // this.$container.on('variantImageChange', this._updateImages.bind(this));
      this.$container.on("variantPriceChange", this._updatePrice.bind(this));
      this.$container.on("variantSKUChange", this._updateSKU.bind(this));
    },

    // init swatches
    _initSwatch: function(currentVariant) {
      var self = this;

      // hide default single option selectors
      $.each(this.cache.$swatches, function(i, ele) {
        var $swatch = $(ele),
          optionIndex = $swatch.data("optionIndex");

        $(".selector-wrapper:eq(" + optionIndex + ")", self.$container).hide();
      });

      // check selected variants on load
      currentVariant.options.forEach(function(value, i) {
        var $swatchInput = $('.swatch-element__input[value="' + value + '"]'),
          $swatchItem = $swatchInput.closest(this.selectors.swatchItems),
          $swatchTooltip = $swatchInput
            .closest(this.selectors.swatches)
            .find(this.selectors.swatchTooltip);

        $swatchInput.attr("checked", true);
        $swatchItem.addClass(this.classes.activeSwatchItem);

        // set tooptip value if there is one
        if ($swatchTooltip.length) {
          $swatchTooltip.html(value);
        }
      }, this);
    },

    // check swatch items availability
    _checkAvailability: function(currentVariant) {
      var available = !currentVariant ? false : currentVariant.available,
        $selectedSwatchInputs = $(".swatch-element__input:checked"),
        $selectedSwatchItems = $selectedSwatchInputs.closest(
          this.selectors.swatchItems
        );

      // reset everythingg
      this.cache.$swatchInputs.attr("disabled", false);
      this.cache.$swatchItems.removeClass(this.classes.soldoutSwatchItem);

      if (!available) {
        $selectedSwatchInputs.attr("disabled", true);
        $selectedSwatchItems.addClass(this.classes.soldoutSwatchItem);
      }
    },

    _handleSwatchOnChange: function(evt) {
      var $this = $(evt.target),
        $swatch = $this.closest(this.selectors.swatches),
        $swatchTooltip = $swatch.find(this.selectors.swatchTooltip),
        value = $this.val(),
        optionIndex = $swatch.data("optionIndex"),
        optionType = $swatch.data("optionType");

      // update active swatch element
      $swatch
        .find(this.selectors.swatchItems)
        .removeClass(this.classes.activeSwatchItem);
      $this
        .closest(this.selectors.swatchItems)
        .addClass(this.classes.activeSwatchItem);

      // change tooptip if there is one
      if ($swatchTooltip.length) {
        $swatchTooltip.html(value);
      }

      // hide irrelavent swatch items
      if (optionType == "gender") {
        this._hideIrlvtSwatchItems(value);
      }

      // update product photos
      // if (optionType == 'color' || optionType == 'colour') {
      //   this._switchProductPhotos(value);
      // }

      // update original selector
      this.cache.$singleOptionSelector
        .eq(optionIndex)
        .val(value)
        .trigger("change");
    },

    _hideIrlvtSwatchItems: function(master) {
      var self = this;

      // capture slaves if the master is not in the map
      if (!this.variantsMap.hasOwnProperty(master)) {
        this._captureSlaves(master);
      }

      var $slaveSwatchItems = $(
        ".swatch-element--" +
          master
            .toLowerCase()
            .split(" ")
            .join("-")
      )
        .closest(".swatch")
        .siblings()
        .find(".swatch-element");

      // reset and hide irrelavent swatch items
      $slaveSwatchItems.removeClass("hide").each(function(i, ele) {
        var $swatchItem = $(ele),
          value = $swatchItem.data("value");

        if (self.variantsMap[master].indexOf(value) == -1) {
          $swatchItem.addClass("hide");
        }
      });
    },

    // help hide irrevlant swatch items
    _captureSlaves: function(master) {
      var totalVariants = this.productSingleObject.variants;
      var slaves = [];

      // loop through current variants and store unique slaves
      var currentVariants = totalVariants
        .filter(function(variant, i) {
          return variant.option1 == master;
        })
        .forEach(function(variant) {
          variant.options.forEach(function(option) {
            if (slaves.indexOf(option) == -1 && option != master) {
              slaves.push(option);
            }
          });
        });

      this.variantsMap[master] = slaves;
    },

    // slate variant chage callback
    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass("visibility-hidden")
          .attr("aria-hidden", "true");

        if (variant.available) {
          $(this.selectors.addToCart).prop("disabled", false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop("disabled", true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
        }
      } else {
        $(this.selectors.addToCart).addClass(this.classes.unavailableAddToCart);
        // $(this.selectors.addToCart).prop('disabled', true);
        // $(this.selectors.addToCartText).text('Select All Required Variants');
        // $(this.selectors.productPrices)
        //   .addClass('visibility-hidden')
        //   .attr('aria-hidden', 'false');
      }
    },

    // slate variant chage callback
    _updatePrice: function(evt) {
      var variant = evt.variant;
      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass("hide");

        $(this.selectors.originalPriceWrapper).addClass(
          this.classes.saleClasse
        );

        $(this.selectors.saleLabel).removeClass("hide");
      } else {
        $(this.selectors.comparePrice).addClass("hide");
        $(this.selectors.saleLabel).addClass("hide");
        $(this.selectors.originalPriceWrapper).removeClass(
          this.classes.saleClasse
        );
      }
    },

    // slate variant chage callback
    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    // update product photos
    _switchProductPhotos: function(color) {
      var colorHandle = theme.Handleize(color),
        self = this;

      self.cache.$productPhotosSlider.slick("slickUnfilter");
      self.cache.$productPhotosSlider.slick(
        "slickFilter",
        ".product__photo--" + colorHandle
      );
    },

    onUnload: function() {
      // Do nothing since we don't have to edit this in the theme editor
    }
  });

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: "screen and (max-width: 767px)",
    mediaQueryMediumUp: "screen and (min-width: 768px)",
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var wrapper = (this.wrapper = ".quotes-wrapper");
    var slider = (this.slider = "#Quotes-" + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data("count");

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on("init", this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick("unslick");
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick("unslick");
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        ".quotes-slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick("slickGoTo", slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr("aria-live");

      // When an element in the slider is focused set aria-live
      $wrapper.on("focusin", function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr("aria-live", "polite");
        }
      });

      // Remove aria-live
      $wrapper.on("focusout", function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr("aria-live");
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr("data-section-id");
    var slideshow = (this.slideshow = "#Slideshow-" + sectionId);

    $(".slideshow__video", slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr("id"));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        ".slideshow__slide--" + evt.detail.blockId + ":not(.slick-cloned)"
      );
      var slideIndex = $slide.data("slick-index");

      // Go to selected slide, pause autoplay
      $slideshow.slick("slickGoTo", slideIndex).slick("slickPause");
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick("slickPlay");
    }
  }
);

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register("cart-template", theme.Cart);
  sections.register("product", theme.Product);
  sections.register("collection-template", theme.Collection);
  sections.register("product-template", theme.Product);
  sections.register("header-section", theme.HeaderSection);
  sections.register("map", theme.Maps);
  sections.register("slideshow-section", theme.SlideshowSection);
  sections.register("quotes", theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $(".in-page-link").on("click", function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on("click", function(evt) {
    evt.preventDefault();
  });

  // init pagination
  theme.Pagination.init();

  // init modal
  theme.Modal.init();
};

$(theme.init);
